export const dateOfBirthFormatter = (dateOfBirth: Date): string => {
    const day = ('0' + dateOfBirth.getDate().toString()).slice(-2);
    const month = ('0' + (dateOfBirth.getMonth() + 1).toString()).slice(-2);
    const year = dateOfBirth.getFullYear().toString();
    return `${year}-${month}-${day}`;
}
